import { Routes } from '@angular/router';
import { accessAdminGuard, accessSuperAdminGuard, authGuard } from './guards/auth.guard';
import { AlarmsComponent } from './pages/alarms/alarms.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DevicesComponent } from './pages/devices/devices.component';
import { LoginComponent } from './pages/login/login.component';
import { MapComponent } from './pages/map/map.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { SuperConsoleComponent } from './pages/super-console/super-console.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: DashboardComponent,
  },
  {
    path: 'devices',
    canActivate: [authGuard],
    component: DevicesComponent,
  },
  {
    path: 'alarms',
    canActivate: [authGuard],
    component: AlarmsComponent,
  },
  {
    path: 'map',
    canActivate: [authGuard],
    component: MapComponent,
  },
  {
    path: 'reports',
    canActivate: [authGuard],
    component: ReportsComponent,
  },
  {
    path: 'settings',
    canActivate: [authGuard, accessAdminGuard],
    component: SettingsComponent,
    loadChildren: () => import('./pages/settings/settings.routes')
      .then(m => m.settingsRoutes),
  },
  {
    path: 'super-console',
    canActivate: [authGuard, accessSuperAdminGuard],
    component: SuperConsoleComponent,
    loadChildren: () => import('./pages/super-console/super-console.routes')
      .then(m => m.superConsoleRoutes),
  },
  {
    path: 'login',
    component: LoginComponent,
  },
];
